var map = {
	"./12BJ.png": "YfS3",
	"./1_1.png": "4jpy",
	"./1_2.png": "dDh4",
	"./2_1.png": "8rng",
	"./2_2.png": "XK3U",
	"./3_1.png": "1TMw",
	"./3_2.png": "5F1j",
	"./4_1.png": "1Vvz",
	"./4_2.png": "7TE4",
	"./CLJG.png": "DoY/",
	"./CYXT.png": "EkP1",
	"./RCFW.png": "qB3J",
	"./SJSS.png": "QwR2",
	"./SJSS1.png": "1Rxa",
	"./WLGX.png": "ZB+d",
	"./WLGX1.png": "JuXN",
	"./WechatIMG0b6dc64839f009d98ddc60da00d9f76b.png": "wig0",
	"./WechatIMG7e65ac20be9d0d6a5ba0fff99ddf6bb6.png": "F/9n",
	"./apps.png": "Hj2J",
	"./b_1.png": "b3Pt",
	"./b_2.png": "UY+j",
	"./b_3.png": "Ix/4",
	"./b_4.png": "iTGF",
	"./center_d.png": "3eWm",
	"./classBanner.png": "mYC8",
	"./company.png": "Y8P+",
	"./company1.png": "9FQk",
	"./company2.png": "SULZ",
	"./cp_icon.png": "yhMY",
	"./down.png": "j/3Z",
	"./emp.png": "z1mJ",
	"./logoBottom.png": "B6K9",
	"./numbers.png": "2LtG",
	"./server.png": "O7zu",
	"./solution.png": "iDPA",
	"./solutionBanner.png": "nOGH",
	"./type_bg.png": "2v32",
	"./up.png": "DU//",
	"./user.png": "bXj7",
	"./vr_icon.png": "lICx",
	"./wei0.png": "bJvm",
	"./wei1.png": "oq1a",
	"./wei2.png": "SHvG",
	"./wei3.png": "j1Mb",
	"./wei4.png": "uu8c",
	"./wei5.png": "F7Rj",
	"./xun0.png": "GBKd",
	"./xun1.png": "EkSZ",
	"./xun2.png": "lpWq",
	"./xun3.png": "yWTu",
	"./xun4.png": "rAl+",
	"./xun5.png": "o/LY"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "XnQO";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home ^\.\/.*\.png$
// module id = XnQO
// module chunks = 0